export enum EhrNotificationAction {
  RedirectToModule = 1,
  RedirectToPage = 2,
}
